export const PAYMENT_ELEMENT_SOURCE = {
  manage_payment_methods: "manage_payment_methods",
  product_purchase: "product_purchase"
}